/**
 * Canonicalize a JS string per RFC 8785 section 3.2.2.2.
 *
 * Escape rules:
 *   1. `"` and `\` receive the two character short form escapes `\"` and `\\`.
 *   2. `U+0008`, `U+0009`, `U+000A`, `U+000C`, `U+000D` receive the single
 *      letter short forms `\b`, `\t`, `\n`, `\f`, `\r` respectively.
 *   3. `U+000B` (vertical tab) has no short form in RFC 8785 and escapes as
 *      `` instead.
 *   4. All other code points in `U+0000` through `U+001F` escape as `\u00XX`
 *      with lowercase hex digits zero padded to four positions.
 *   5. Every other code point, including all non ASCII characters, is emitted
 *      raw. No `\uXXXX` form is used for non control characters.
 *
 * Iteration walks UTF-16 code units. Surrogate pairs are emitted as is, which
 * reproduces the original code point when the output string is later UTF-8
 * encoded (for example by TextEncoder).
 */
export function canonicalizeString(input: string): string {
  let output = '"'
  for (let index = 0; index < input.length; index++) {
    const charCode = input.charCodeAt(index)
    if (charCode === 0x22) {
      output += '\\"'
    } else if (charCode === 0x5c) {
      output += '\\\\'
    } else if (charCode === 0x08) {
      output += '\\b'
    } else if (charCode === 0x09) {
      output += '\\t'
    } else if (charCode === 0x0a) {
      output += '\\n'
    } else if (charCode === 0x0c) {
      output += '\\f'
    } else if (charCode === 0x0d) {
      output += '\\r'
    } else if (charCode < 0x20) {
      output += '\\u' + charCode.toString(16).padStart(4, '0')
    } else {
      output += input[index]
    }
  }
  return output + '"'
}
